import React from 'react';
import {
  customType,
  extend, fragment,
  namedFragment,
  params,
  QueryProvider,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { BentoHero as BentoHeroComponent } from '@thd-olt-component-react/hero';
import { SponsoredBanner } from '@thd-olt-component-react/sponsored-content';
import { arrayOf, element, shape, string } from 'prop-types';
import { Experience } from '@ninetailed/experience.js-react';
import { getNinetailedDataModel, getNinetailedExperience } from '../utils/ninetailed';
import { BentoHeroModel } from '../datamodels/home';

// eslint-disable-next-line camelcase
export function BentoHero({ id, nt_experiences }) {
  const experiences = getNinetailedExperience(nt_experiences, BentoHeroComponent, 'BentoHero');
  return (
    <ErrorBoundary name="bento-hero">
      <QueryProvider
        cacheKey="bento-hero-cache-nt"
        defaultVariables={{ isCarousel: false }}
      >
        <Renderer
          id={id}
          Component={BentoHeroComponent}
          experiences={experiences}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

const Renderer = ({ id, Component, experiences }) => {
  if (!experiences || experiences.length === 0) {
    return (
      <Component
        componentId={id}
        componentClass="BentoHero"
      />
    );
  }
  return (
    <Experience
      id={id}
      componentId={id}
      component={Component}
      experiences={experiences}
      passthroughProps={{
        componentClass: 'BentoHero',
      }}
    />
  );
};

Renderer.propTypes = {
  id: string.isRequired,
  Component: element.isRequired,
  experiences: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      type: string.isRequired,
      config: shape({}).isRequired,
      audience: shape({
        id: string.isRequired,
        name: string.isRequired,
      }).isRequired,
      variants: arrayOf(shape({
        id: string.isRequired,
        componentId: string.isRequired,
        componentClass: string.isRequired,
      })).isRequired
    })
  ).isRequired
};

Renderer.dataModel = extend({
  component: params({
    id: stringType()
      .isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['BentoHero'])
      .isRequired(),
  }).shape({
    BentoHero: namedFragment({
      inline: true,
      fragmentType: 'BentoHero',
      fragmentAlias: 'BentoHeroV2'
    }).shape({
      ...BentoHeroModel.dataModel,
    })
  })
},
SponsoredBanner
);

BentoHero.propTypes = {
  id: string.isRequired,
  nt_experiences: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      type: string.isRequired,
      config: shape({}).isRequired,
      audience: shape({
        id: string.isRequired,
        name: string.isRequired,
      }).isRequired,
      variants: arrayOf(shape({
        id: string.isRequired,
        componentId: string.isRequired,
        componentClass: string.isRequired,
      })).isRequired
    })
  )
};

BentoHero.defaultProps = {
  nt_experiences: []
};
